import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

const NotificationModal = ({
  children,
  buttonName = '',
  useIconButton = true,
  name,
  icon = 'fas fa-info-circle',
  color = 'success',
  tooltipTitle = '',
  showCloseButton = true,
  showSubmitButton = false,
  stopPlay
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
    if (isOpen && typeof stopPlay !== 'undefined') {
      stopPlay();
    }
  };

  return (
    <>
      <Button
        size="sm"
        color={color}
        title={tooltipTitle}
        onClick={toggleModal}
      >
        {useIconButton && <i className={icon}></i>}
        {buttonName}
      </Button>

      <Modal
        className="modal-dialog-centered"
        isOpen={isOpen}
        toggle={toggleModal}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-default">
            {name}
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={toggleModal}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <ModalBody>
          <hr style={{ marginTop: '-30px' }} />
          {children}
        </ModalBody>

        <ModalFooter>
          {showCloseButton && (
            <Button
              color="danger"
              data-dismiss="modal"
              type="button"
              onClick={toggleModal}
            >
              Fechar
            </Button>
          )}

          {showSubmitButton && (
            <Button color="primary" type="submit">
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default NotificationModal;
